// extracted by mini-css-extract-plugin
module.exports = {"top-level-link":"Links_top-level-link___ty7O","icon":"Links_icon__bHfyz","inline-link":"Links_inline-link__3x8uB"};